module.exports = __webpack_public_path__ + "img/pr-2.e33acb5f.png";